module.exports = {
    USER_SETTINGS_FALLBACK: 'USER_SETTINGS_FALLBACK',
};
